export default {
    bookingStart: "Start",
    calendar: "Kalender",
    general: "Kontakt",
    bookings: "Details",
    payment: "Zahlung",
    overview: "Zusammenfassung"
}
